import React from 'react';
import styled from 'styled-components';
import TrueImpactLevelFeedbackModal from 'shared/design-system/components/TrueImpactLevelFeedbackModal';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import {
  REACH_SUCCEED_MATCH_MESSAGE,
  REACH_SUCCEED_MATCH_NOTE_PLACEHOLDER,
  ReachSucceedMatch,
} from './reachSucceedMatchUtils';

const MessageParagraph = styled.p`
  margin: 0;
  line-height: 1.7;
`;

const MatchParagraph = styled(MessageParagraph)`
  margin-top: ${SPACERS.tiny};
`;

interface ReachSucceedMatchModalProps {
  open: boolean;
  matches: ReachSucceedMatch[];
  initialNote: string;
  isInterimStage: boolean;
  isSaving: boolean;
  errorMessage: string;
  onClose: () => void;
  onConfirm: (note: string) => void;
}

const ReachSucceedMatchModal: React.FC<ReachSucceedMatchModalProps> = ({
  open,
  matches,
  initialNote,
  isInterimStage,
  isSaving,
  errorMessage,
  onClose,
  onConfirm,
}) => {
  const fieldLabel = (match: ReachSucceedMatch): string => {
    if (match.field === 'forecast') return 'Forecast';
    return isInterimStage ? 'Updated Forecast' : 'Final Results';
  };

  return (
    <TrueImpactLevelFeedbackModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmText="Save"
      initialNote={initialNote}
      isSaving={isSaving}
      errorMessage={errorMessage}
      placeholder={REACH_SUCCEED_MATCH_NOTE_PLACEHOLDER}
      message={
        <>
          <MessageParagraph>{REACH_SUCCEED_MATCH_MESSAGE}</MessageParagraph>
          {matches.map(match => (
            <MatchParagraph
              key={`${match.indicator.indicatorId}-${match.field}`}
            >
              <strong>{match.indicator.indicatorName}</strong> (
              {fieldLabel(match)}): {match.value} —{' '}
              {match.matches.map(m => m.indicatorName).join(', ')}
            </MatchParagraph>
          ))}
        </>
      }
    />
  );
};

export default ReachSucceedMatchModal;
